export default {
    default: [
        {
            component: 'install',
            route: 'install',
            name: 'Installation',
        },
    ],
};



// WEBPACK FOOTER //
// ./src/schema.js